// removed by extract-text-webpack-plugin
module.exports = {"newslist_item":"newsList__newslist_item__1YbxA","newsList_wrapper":"newsList__newsList_wrapper__3gLlL","newsList_wrapper_enter":"newsList__newsList_wrapper_enter__1uDv9","flexWrapper":"newsList__flexWrapper__2TDCx","left":"newsList__left__1kUAd","right":"newsList__right__3PeMm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/NewsList/newsList.css
// module id = 832
// module chunks = 0